import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


import { VersionsModule } from '@core/components/versions/versions.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';
import { HelperFormModule } from '@core/components/helpers/form/form.module';
import { LayoutModule } from '@core/components/layout/layout.module';
import { ShareModule } from '@app/components/share/share.module';
import { HelperNavigationModule } from '@core/components/helpers/navigation/navigation.module';
import { ShareFeedbackCoreComponentsModule } from '../../Core/components/components.module';
import { CoreProjectsModule } from '@core/components/projects/projects.module';

import { PluginShareFeedbackMainAppComponent } from './main/main.component';
import { ShareFeedbackAppSectionsModule } from './sections/sections.module';
@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        VersionsModule,
        HelperBoxModule,
        HelperFormModule,
        HelperNavigationModule,
        CoreProjectsModule,
        LayoutModule,
        ShareModule,
        ShareFeedbackAppSectionsModule,
        ShareFeedbackCoreComponentsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        PluginShareFeedbackMainAppComponent,
    ],
    exports: [
        PluginShareFeedbackMainAppComponent,
        ShareFeedbackAppSectionsModule
    ],

})
export class ShareFeedbackAppComponentsModule { }
